<template>
  <v-container fluid style="height: 100%">
    <simple-history :histories="histories" :functionCategory="functionCategory"></simple-history>
  </v-container>
</template>

<script>
import SimpleHistory from "../common/SimpleHistory.vue";
import { statuses as ApiStatus } from "../../libs/api-client";
export default {
  name: "PropositionDetailHistory",
  props: ["propositionDetailId"],
  components: {
    SimpleHistory,
  },
  data() {
    return {
      histories: {},
      functionCategory: "",
    };
  },
  mounted: async function () {
    this.onSearchHistory();
  },
  watch: {
    propositionDetailId() {
      this.onSearchHistory();
    },
  },
  methods: {
    onSearchHistory: async function () {
      try {
        if (!this.propositionDetailId) {
          this.histories = [];
          return;
        }
        this.$store.commit("ui/loading", true);
        this.functionCategory = "propositiondetail";
        console.log("this.propositionDetailId", this.propositionDetailId);
        let response = await this.$store.dispatch("propositionDetail/history", this.propositionDetailId);

        if (ApiStatus.isSystemError(response.data?.header)) {
          return this.redirectError();
        }
        console.log(response.data.contents);
        this.histories = response.data.contents.histories;
        this.$store.commit("ui/loading", false);
      } catch (error) {
        console.error("error:", this.$options._componentTag);
        //return this.redirectError();
      } finally {
        this.loadingOff();
      }
    },
  },
};
</script>
